import { render, staticRenderFns } from "./entrust-succes.vue?vue&type=template&id=cdfe1048&scoped=true&"
import script from "./entrust-succes.vue?vue&type=script&lang=js&"
export * from "./entrust-succes.vue?vue&type=script&lang=js&"
import style0 from "./entrust-succes.vue?vue&type=style&index=0&id=cdfe1048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfe1048",
  null
  
)

export default component.exports